export enum FileSystemKey {
  FILE_SEARCH = 'fileSearch',
  SHARED = 'shared',
}
